var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBronze(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1590 1614",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #b06518;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #fffae6;\n      }\n\n      .cls-19 {\n        opacity: .6;\n      }\n\n      .cls-19, .cls-20, .cls-21, .cls-6, .cls-7, .cls-9, .cls-15, .cls-16 {\n        mix-blend-mode: overlay;\n      }\n\n      .cls-20, .cls-16 {\n        opacity: .35;\n      }\n\n      .cls-21, .cls-7 {\n        opacity: .49;\n      }\n\n      .cls-22 {\n        mask: url(#mask);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-23 {\n        filter: url(#luminosity-noclip);\n      }\n\n      .cls-4 {\n        opacity: .7;\n      }\n\n      .cls-4, .cls-15, .cls-17 {\n        fill: #fff;\n      }\n\n      .cls-5 {\n        fill: url(#radial-gradient);\n        mix-blend-mode: multiply;\n      }\n\n      .cls-6 {\n        opacity: .2;\n      }\n\n      .cls-6, .cls-7, .cls-8, .cls-9, .cls-16 {\n        fill: #fff6cc;\n      }\n\n      .cls-9 {\n        opacity: .23;\n      }\n\n      .cls-10 {\n        fill: #ffb797;\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-24 {\n        isolation: isolate;\n      }\n\n      .cls-25 {\n        mask: url(#mask-1);\n      }\n\n      .cls-18 {\n        fill: #723600;\n        opacity: .44;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 763.84,
    y1: 449.14,
    x2: 837.95,
    y2: 793.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#e38250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#bd6e50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#572600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 554.83,
    y1: 599.49,
    x2: 579.9,
    y2: 1209.81,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 9004.99,
    y1: 599.52,
    x2: 9030.06,
    y2: 1209.83,
    gradientTransform: "translate(10025.62) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 777.94,
    y1: 590.34,
    x2: 803,
    y2: 1200.64,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 829.45,
    y1: 1102.33,
    x2: 769.51,
    y2: 804.81,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 653.72,
    y: 612.13,
    width: 119.9,
    height: 111.65,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-2",
    x: 653.72,
    y: -9807,
    width: 119.9,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-1",
    x: 653.72,
    y: -9807,
    width: 119.9,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 713.67,
    cy: 667.96,
    fx: 713.67,
    fy: 667.96,
    r: 57.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#7e7e7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#393939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 653.72,
    y: 612.13,
    width: 119.9,
    height: 111.65,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M713.68,612.13c-33.1,0-59.95,25-59.95,55.85s26.85,55.8,59.95,55.8,59.94-25.01,59.94-55.8-26.85-55.85-59.94-55.85Z"
  })))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "790.36 409.7 675.31 572.38 790.36 735.07 905.42 572.38 790.36 409.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "790.36 425.15 899.95 580.11 905.42 572.38 790.36 409.7 675.31 572.38 680.77 580.11 790.36 425.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "790.43 734.04 904.76 572.38 790.43 410.72 790.43 734.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "793.36 607.5 791.19 410.87 790.36 409.7 678.85 567.37 784 500.4 793.36 607.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "790.36 412.79 783.46 538.62 791.09 607.5 793.37 538.19 790.36 412.79"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M716.21,1193.02s-55.41,26.82-151.95-11.32c-96.53-38.14-127.22-88.49-127.22-88.49l51.39-29.94s-53.56-41.97-75.01-119.43c-21.45-77.46-18.99-87.26-18.99-87.26h47.67s-14.3-16.5,11.92-101.11c26.22-84.62,51.25-101.21,51.25-101.21l35.75,36.99s15.49-38.11,54.82-71.48c39.33-33.37,79.85-47.66,79.85-47.66l51.93,68.07-11.41,552.85Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M422.15,957.34c-21.45-77.46-18.99-86.83-18.99-86.83h47.67s-14.3-16.93,11.92-101.54c26.22-84.62,51.24-101.42,51.24-101.42l35.75,36.88s15.49-38.16,54.82-71.53c34.04-28.89,68.95-43.49,77.73-46.89l-6.6-13.89s-40.52,14.29-79.85,47.67c-39.33,33.36-54.82,71.5-54.82,71.5l-35.75-36.96s-25.03,16.51-51.25,101.13c-26.22,84.61-11.92,101.11-11.92,101.11h-47.67s-2.46,9.79,18.99,87.26c8.91,32.17,23.36,58.39,37.21,77.82-10.93-17.53-21.44-38.88-28.49-64.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M504.1,1061.77s-1.34-2.09-19.06,3.49l-48,27.96s2.92,4.77,9.74,12.48l57.31-43.93Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M727.62,640.19l-51.93-68.06s-40.52,14.3-79.85,47.67c-39.33,33.37-54.82,71.5-54.82,71.5l-35.75-36.96s-25.03,16.52-51.25,101.14c-26.22,84.61-11.92,101.11-11.92,101.11h-47.67s-2.46,9.79,18.99,87.26c21.45,77.46,75.01,119.36,75.01,119.36l-51.39,29.98s10.15,16.62,37.03,37.97c24.21,5.51,49.41,8.43,75.29,8.43,60.1,0,116.52-15.69,165.43-43.19l12.83-456.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M712.97,973.44l14.65-333.26-51.93-68.06s-40.52,14.3-79.85,47.67c-39.33,33.37-54.82,71.5-54.82,71.5l-35.75-36.96s-25.03,16.52-51.25,101.14c-26.22,84.61-11.92,101.11-11.92,101.11h-47.67s-2.46,9.79,18.99,87.26c1.02,3.68,2.13,7.33,3.29,10.86,44.38,35.2,100.5,56.26,161.54,56.26,49.32,0,95.42-13.69,134.72-37.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M711.17,850.99l16.45-210.8-51.93-68.06s-40.52,14.3-79.85,47.67c-39.33,33.37-54.82,71.5-54.82,71.5l-35.75-36.96s-24.32,16.24-50.13,97.76c32.08,67.29,100.73,113.79,180.25,113.79,26.83,0,52.42-5.31,75.79-14.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M567.61,648.77c19.31,39.75,60.07,67.15,107.23,67.15,11.91,0,23.41-1.77,34.27-5.02l18.51-70.72-51.93-68.06s-40.52,14.3-79.85,47.67c-11.32,9.61-20.66,19.6-28.23,28.98Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M442.1,848.23s-3.03-3.55-3.74-15.63c-.32,6.66-.07,10.06.44,15.63h3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M564.26,1170.8c-73.74-29.13-109.03-65.36-121.6-80.86l-5.62,3.28s30.69,50.35,127.22,88.49c96.53,38.14,151.95,11.32,151.95,11.32l-.16-10.82c-3.29,1.51-58.22,25.56-151.78-11.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M488.11,1063.27l15.99-2.59s-69.38-50.27-90.83-127.73c-11.89-42.97-16.27-65.22-17.96-76.36h-.87s-2.62,9.79,18.83,87.26c16.53,59.69,54.87,103.4,74.85,119.43Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M858.6,1193.02s55.41,26.82,151.95-11.32c96.53-38.14,127.22-88.49,127.22-88.49l-51.4-29.94s53.56-41.97,75.01-119.43c21.45-77.46,18.99-87.26,18.99-87.26h-47.67s14.3-16.5-11.92-101.11c-26.22-84.62-51.25-101.21-51.25-101.21l-35.75,36.99s-15.49-38.11-54.82-71.48c-39.33-33.37-79.85-47.66-79.85-47.66l-50.63,68.07,10.11,552.85Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1152.66,957.34c21.45-77.46,18.99-86.83,18.99-86.83h-47.67s14.3-16.93-11.92-101.54c-26.22-84.62-51.25-101.42-51.25-101.42l-35.75,36.88s-15.49-38.16-54.82-71.53c-34.04-28.89-68.95-43.49-77.73-46.89l6.6-13.89s40.52,14.29,79.85,47.67c39.33,33.36,54.82,71.5,54.82,71.5l35.75-36.96s25.03,16.51,51.25,101.13c26.22,84.61,11.92,101.11,11.92,101.11h47.67s2.46,9.79-18.99,87.26c-8.91,32.17-23.36,58.39-37.21,77.82,10.93-17.53,21.44-38.88,28.49-64.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1070.71,1061.77s1.34-2.09,19.06,3.49l48,27.96s-2.92,4.77-9.75,12.48l-57.31-43.93Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M848.49,640.19l50.63-68.06s40.52,14.3,79.85,47.67c39.33,33.37,54.82,71.5,54.82,71.5l35.75-36.96s25.03,16.52,51.25,101.14c26.22,84.61,11.92,101.11,11.92,101.11h47.67s2.46,9.79-18.99,87.26c-21.45,77.46-75.01,119.36-75.01,119.36l51.4,29.98s-10.15,16.62-37.03,37.97c-24.21,5.51-49.41,8.43-75.29,8.43-60.1,0-116.52-15.69-165.43-43.19l-11.53-456.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M861.84,973.44l-13.34-333.26,50.63-68.06s40.52,14.3,79.85,47.67c39.33,33.37,54.82,71.5,54.82,71.5l35.75-36.96s25.03,16.52,51.25,101.14c26.22,84.61,11.92,101.11,11.92,101.11h47.67s2.46,9.79-18.99,87.26c-1.02,3.68-2.14,7.33-3.29,10.86-44.37,35.2-100.5,56.26-161.54,56.26-49.32,0-95.42-13.69-134.72-37.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M863.64,850.99l-15.15-210.8,50.63-68.06s40.52,14.3,79.85,47.67c39.33,33.37,54.82,71.5,54.82,71.5l35.75-36.96s24.32,16.24,50.13,97.76c-32.08,67.29-100.73,113.79-180.24,113.79-26.83,0-52.42-5.31-75.79-14.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1007.2,648.77c-19.31,39.75-60.07,67.15-107.23,67.15-11.92,0-23.41-1.77-34.27-5.02l-17.21-70.72,50.63-68.06s40.52,14.3,79.85,47.67c11.32,9.61,20.66,19.6,28.23,28.98Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1132.71,848.23s3.03-3.55,3.74-15.63c.32,6.66.07,10.06-.44,15.63h-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1010.55,1170.8c73.74-29.13,109.03-65.36,121.6-80.86l5.62,3.28s-30.69,50.35-127.22,88.49c-96.53,38.14-151.95,11.32-151.95,11.32l.16-10.82c3.29,1.51,58.22,25.56,151.79-11.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1086.69,1063.27l-15.98-2.59s69.38-50.27,90.83-127.73c11.89-42.97,16.27-65.22,17.96-76.36h.87s2.62,9.79-18.83,87.26c-16.53,59.69-54.87,103.4-74.85,119.43Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M791.18,621.15c-165.64,0-299.9,130.54-299.9,291.56s134.26,291.59,299.9,291.59,299.89-130.56,299.89-291.59-134.28-291.56-299.89-291.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M790.28,1191.23c-163.38,0-296.23-127.05-299.81-285.06-.05,2.18-.09,4.35-.09,6.54,0,161.03,134.26,291.59,299.9,291.59s299.89-130.56,299.89-291.59c0-2.19-.04-4.36-.09-6.54-3.58,158.01-136.44,285.06-299.8,285.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M791.18,621.15c-165.64,0-299.9,130.54-299.9,291.56,0,3.56.16,7.04.3,10.57,76.39,66.61,181.56,107.8,297.65,107.8s224.95-42.66,301.63-111.34c.06-2.36.2-4.65.2-7.02,0-161.02-134.28-291.56-299.89-291.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1030.49,736.26c-54.76-69.92-141.29-115.11-238.68-115.11s-185.27,45.86-239.97,116.7c67.8,40.7,149.76,64.54,238.03,64.54s172.32-24.45,240.62-66.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M791.18,637.83c162.72,0,295.09,126.09,299.65,283.22.1-2.76.23-5.54.23-8.34,0-161.02-134.28-291.56-299.89-291.56s-299.88,130.54-299.88,291.56c0,2.81.14,5.59.22,8.34,4.56-157.13,136.92-283.22,299.66-283.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M750.91,640.32c13.96-1.07,28.34,4.24,21.37,10.31-6.99,6.07-54.18,33.29-74.76,16.47-20.62-16.85,36.97-25.52,53.39-26.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M588.65,714.46c-43.69,36.76-79,104.68-78.11,144.36.89,39.67,22.09-22.58,33.04-45.17,10.97-22.56,65.69-91.46,105.36-112.29,39.69-20.87,8.05-44.39-60.28,13.09Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M791.2,695.62c-123.15,0-222.98,97.08-222.98,216.8s99.83,216.8,222.98,216.8,222.96-97.07,222.96-216.8-99.8-216.8-222.96-216.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M790.83,1143.66c-129.83,0-235.46-102.83-235.46-229.22s105.63-229.22,235.46-229.22,235.44,102.83,235.44,229.22-105.62,229.22-235.44,229.22ZM790.83,706.02c-118.36,0-214.66,93.49-214.66,208.41s96.3,208.42,214.66,208.42,214.63-93.49,214.63-208.42-96.28-208.41-214.63-208.41Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M791.2,695.62c-65.39,0-124.22,27.38-165,71.01,39.8-35.97,93.1-57.96,151.72-57.96,123.13,0,222.95,97.04,222.95,216.78,0,56.17-21.95,107.33-57.98,145.84,43.85-39.6,71.26-96.11,71.26-158.88,0-119.71-99.8-216.8-222.96-216.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M652.32,1040.66c0-139.91,99.83-216.79,222.96-216.79,50.32,0,96.73,16.2,134.02,43.53-21.3-98.13-110.86-171.78-218.13-171.78-123.13,0-222.96,97.08-222.96,216.8,0,70.86,34.94,133.73,88.95,173.3-3.13-14.54-4.83-29.6-4.83-45.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M791.2,1117.39c-120.99,0-219.4-93.74-222.78-210.58-.09,2.08-.2,4.14-.2,6.23,0,119.76,99.83,216.8,222.98,216.8s222.96-97.04,222.96-216.8c0-2.09-.09-4.15-.15-6.23-3.42,116.84-101.8,210.58-222.8,210.58Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M713.68,612.13c-33.1,0-59.95,25-59.95,55.85s26.85,55.8,59.95,55.8,59.94-25.01,59.94-55.8-26.85-55.85-59.94-55.85Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M658.93,741.44c16.09-18.06,63.39-73.46,63.39-73.46,0,0,39.52-74.15,40.47-76.23.27-.6-50.5,69.72-50.5,69.72l-53.37,79.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M726.71,654.71c-14.58-11.41-11.93-43.45-12.04-52.53v8.69c0-1.39-.11-2.89-.11-3.21v-5.48c-.02,2.6-.2,6.72-.81,11.48,0,0-4.28,32.16-11.98,38.81-17.36,15.23-61.06,12.29-44.3,12.69,56.59,1.22,56.59,56.45,57.1,74.58v-9.12c.04.65.11,1.2.11,1.52v7.6c1.2-42.89,1.05-70.03,50.43-73.65,16.35-1.26-21.34,1.9-38.39-11.38Z"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBronze);
export default __webpack_public_path__ + "static/media/bronze.7fcc72d46b659043ab9514f8eced1b6b.svg";
export { ForwardRef as ReactComponent };